import { render } from "./KpiColumnBoard.vue?vue&type=template&id=3c61002f&scoped=true"
import script from "./KpiColumnBoard.vue?vue&type=script&lang=js"
export * from "./KpiColumnBoard.vue?vue&type=script&lang=js"

import "./KpiColumnBoard.vue?vue&type=style&index=0&id=3c61002f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c61002f"]])

export default __exports__